import React from "react";
import { motion } from "framer-motion";

export const PageTransition = ({ children, testId = "page-transition" }) => {
  return (
    <motion.main
      data-testid={testId}
      initial={{ opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -8 }}
      transition={{ duration: 0.7, ease: [0.22, 0.65, 0.2, 1] }}
      className="relative"
    >
      {children}
    </motion.main>
  );
};

export default PageTransition;
